const routes = [
  {
    name: 'wechatRouter',
    path: '/progress',
    component: () => import('@pages/we-chat/router'),
  },
  {
    name: 'wechatFollow',
    path: '/wechat/follow',
    component: () => import('@pages/we-chat/follow'),
  },
  {
    name: 'wechatAuthorization',
    path: '/wechat/authorization',
    component: () => import('@pages/we-chat/authorization'),
  },
];

export default routes;
